module.exports = __webpack_public_path__ + "static/media/car-is-wrong.bc81423b.mp3";